import { render } from "./ShowStore.vue?vue&type=template&id=87abaa2e"
import script from "./ShowStore.vue?vue&type=script&lang=js"
export * from "./ShowStore.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__